export default {
    getHadToken(state) {
        return state.hadToken || localStorage.getItem("wwt") !== null;
    },

    getToken(state) {
        return state.token;
    },
};
